export const useAddressForm = (setValue) => {
  const fillForm = ({ city, neighborhood, street, uf }) => {
    setValue('street', street)
    setValue('neighborhood', neighborhood)
    setValue('city', city)
    setValue('state', uf.toUpperCase())
  }

  return { fillForm }
}
